import {
    GET_DRIVER_LIST,
    DRIVER_LIST_RESPONCE,
    CHANGE_DRIVER_DEPOTS,
    CHANGE_DRIVER_DEPOTS_REDUX_STATE,
    UPDATE_REDUX_STATE
    
    
} from "./actionTypes";


/**
 * Returns an action object to get the driver list.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, success, and failure properties.
 */
export const getDriverList = (success, failure) => {
  return {
    type: GET_DRIVER_LIST,
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
 }

 /**
  * Creates an action object for the driver list response.
  * @param {any} data - The data payload for the action.
  * @returns {Object} An action object with the type and payload.
  */
 export const driverListResponce = data => {
  return {
    type: DRIVER_LIST_RESPONCE,
    payload: data,
  }
}

/**
 * Action creator function that creates an action to change the driver depot.
 * @param {string} id - The ID of the driver depot to change.
 * @param {object} data - The data to update the driver depot with.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with type, payload, success, and failure properties.
 */
export const changeDriverDepot = (id, data, success, failure) => {
  return {
    type: CHANGE_DRIVER_DEPOTS,
    payload: {id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
 }


 /**
  * Action creator function that creates an action to change the Redux state for the driver depots.
  * @param {any} data - The data to be included in the action payload.
  * @returns {object} An action object with a type and payload.
  */
 export const changeDriverDepotReduxState = (data) => {
  return {
    type: CHANGE_DRIVER_DEPOTS_REDUX_STATE,
    payload: data,
  }
}


/**
 * Action creator function that creates an action to update the Redux state with the given data.
 * @param {any} data - The data to update the Redux state with.
 * @returns {object} An action object with a type of UPDATE_REDUX_STATE and a payload of the data.
 */
export const updateDriverReduxState = (data) => {
  return {
    type: UPDATE_REDUX_STATE,
    payload: data,
  }
}



